// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "form_submission".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { consentFormSubmissionStatusValues, formKindValues } from '@borradh-workspace/labels';
/** Response atom for the "form_submission" table (1:1 with a DB row, on the wire). */
export const formSubmissionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    formId: z.string(),
    kind: z.enum(formKindValues),
    patientVisibility: z.enum(['staff_only', 'patient']),
    leadId: z.string().nullable(),
    appointmentId: z.string().nullable(),
    fieldsSnapshot: z.unknown(),
    answers: z.unknown().nullable(),
    status: z.enum(consentFormSubmissionStatusValues),
    tokenHash: z.string().nullable(),
    sentAt: z.string().datetime().nullable(),
    reminderSentAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=formSubmission.js.map